import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import { Container, Col} from 'react-bootstrap';
import PropertyListComponent from './PropertyListComponent';


const Property = () => {
  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Property', link: '/Property-list', active: true },
  ];

  return (  
    <>
      <div className="bread-crumb">
        <Container>
          <Col md={8}>
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>

      <PropertyListComponent 
        route={`/property`} 
        method={"POST"}
        apiPath={`/property/list`}
        requiresAuth={true}
      />
      
    </>
  ); 
};

export default Property;
